const Price = ({ priceData, withVat = true }) => {
  if (!priceData) {
    return '';
  }

  const priceFormatted = withVat
    ? priceData?.priceFormatted
    : priceData?.priceWithoutVatFormatted;

  return (
    <span className={'whitespace-nowrap'}>
      {priceFormatted ?? ''}
    </span>
  );
};

export default Price;